module.exports = __webpack_public_path__ + "01_glasses_black.a30afd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/01_glasses_black.png
// module id = gpKM
// module chunks = 0